import {connect} from "react-redux"
import {FacetState} from "models/FacetsState"
import State from "../../../models/State"
import {searchForSelectedFacets, searchForKeyFilters} from "../../../ducks/tabbedFilters"
import {getSearchCategoryThumbnail} from "../../../utils/getSearchCategoryThumbnail"

type StateProps = {
    filterState: FacetState
    siteUrl: string
    imagePath: string
}

const mapStateToProps = (state: State, ownProps: any) => {
    const {filterName, facetName} = ownProps
    const {facets: filters} = state.tabbedFilters
    const {
        searchCategory: {id: searchCategoryId},
        searchCategoryThumbnails,
        currentBreakpoint,
        showCategoryThumbnails,
    } = state.search
    const {siteUrl} = state.request
    const filterState = filters[filterName]

    const v = filterState ? filterState.v : ""

    const imagePath = showCategoryThumbnails
        ? getSearchCategoryThumbnail(
              searchCategoryThumbnails,
              searchCategoryId,
              facetName,
              v.replace(`${facetName}:`, ""),
              currentBreakpoint,
          )
        : null
    return {
        facetName,
        filterState,
        siteUrl,
        imagePath: imagePath?.imagePath,
    } as StateProps
}

export const mapDispatchToProps = (dispatch: any) => ({
    onFilterSelect: ({
        isTabbedFilter,
        filterName,
        facetName,
    }: {
        isTabbedFilter?: boolean
        filterName: string
        facetName?: string
    }) => {
        if (isTabbedFilter) {
            dispatch(searchForSelectedFacets({child: filterName, parent: facetName as any}))
        } else {
            dispatch(searchForKeyFilters(filterName))
        }
    },
})

export default connect(mapStateToProps, mapDispatchToProps)
